export class UsuarioFilter {
	public rut: string;
	public nombre: string;
	public emisorId: string;
	public usuarioId: string;
	public comuna: string;
	public activo: number;
	public sucursalId: string;
	public email: string;
}
